/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import AccessDeniedSvg from './403.svg';
import {MessagesContext} from '../messages/messages-context';
import ImageLoader, {FormatImgSrc} from '../titles/asset-title/images/image-loader';

class AccessDenied extends Component {

    static get propTypes() {
        return {
            hasHeader: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            hasHeader: true
        };
    }

    static contextType = MessagesContext;

    render() {
        let bodyText;
        let header;

        if (!this.props.hasHeader) {
            bodyText = <p>{this.context.intl.messages['errors.access-denied.body']}</p>;
            header = <div className="text-center">
                <h1><strong>{this.context.intl.messages['errors.access-denied.title']}</strong></h1>
            </div>;
        } else {
            bodyText = <p>{this.context.intl.messages['errors.access-denied.body']}<br/>
                {this.context.intl.messages['errors.access-denied.return-to']} <Link to="/">{this.context.intl.messages['errors.access-denied.homepage']}</Link>.
            </p>;
            header = <div className="row title-header">
                <div className="title-header-text text-center">
                    <h1><strong>{this.context.intl.messages['errors.access-denied.title']}</strong></h1>
                </div>
            </div>;
        }

        return (
            <>
                {header}
                <div className="container">
                    <div className="row">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-4">
                            <div className="padding-y-20">
                                <ImageLoader
                                    alt="..."
                                    className="img-responsive"
                                    src={FormatImgSrc(AccessDeniedSvg) || '/403.svg'}
                                />
                            </div>
                            <div className="text-center padding-y-10">
                                {bodyText}
                            </div>
                        </div>
                        <div className="col-sm-4"></div>
                    </div>
                </div>
            </>
        );
    }
}

export default AccessDenied;
